import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["requirements", "template"]

  addRequirement(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.requirementsTarget.insertAdjacentHTML("beforeend", content)
  }

  removeRequirement(event) {
    event.preventDefault()
    const item = event.target.closest(".requirement")
    const destroyField = item.querySelector("input[name*='_destroy']")
    if (destroyField) {
      destroyField.value = "1"  // mark for destruction
      item.style.display = "none"
    } else {
      item.remove()
    }
  }
}
